module.exports = __webpack_public_path__ + "img/stca.1869dc1.png";